const trimSlash = (value) => String(value || "").replace(/\/+$/, "");

export const getAnalyticsConfig = () => {
  const enabledEnv = process.env.REACT_APP_ANALYTICS_ENABLED;
  const monitoraBase = trimSlash(process.env.REACT_APP_API_MONITORA);
  const endpoint =
    process.env.REACT_APP_ANALYTICS_URL ||
    (monitoraBase ? `${monitoraBase}/analytics/events` : "");

  const enabledExplicit = String(enabledEnv || "").toLowerCase();
  const enabled =
    enabledExplicit === "true" ||
    (enabledExplicit !== "false" && Boolean(endpoint));

  return {
    applicationId: "SGU WEB",
    endpoint,
    enabled,
    flushIntervalMs: Number(process.env.REACT_APP_ANALYTICS_FLUSH_MS) || 5000,
    maxBatch: Math.min(
      Number(process.env.REACT_APP_ANALYTICS_MAX_BATCH) || 10,
      50
    ),
    idleMs: Number(process.env.REACT_APP_ANALYTICS_IDLE_MS) || 30 * 60 * 1000,
  };
};
